/**
 * PIXI Mock工具
 * 用于在特定环境下mock PIXI，保持API一致但不实际加载spine资源
 */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const createMockPIXI = () => {
    // 创建mock的spine state对象
    const createMockSpineState = () => {
        return {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            setAnimation(trackIndex: number, animationName: string, loop: boolean) {
                // 什么都不做
                console.log(`[PIXI Mock] setAnimation(${trackIndex}, ${animationName}, ${loop}) - noop`);
            },
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            addAnimation(trackIndex: number, animationName: string, loop: boolean, delay?: number) {
                // 什么都不做
                console.log(`[PIXI Mock] addAnimation(${trackIndex}, ${animationName}, ${loop}) - noop`);
            },
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            setEmptyAnimation(trackIndex: number, mixDuration: number) {
                // 什么都不做
                console.log(`[PIXI Mock] setEmptyAnimation(${trackIndex}, ${mixDuration}) - noop`);
            },
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            clearTracks() {
                // 什么都不做
                console.log(`[PIXI Mock] clearTracks() - noop`);
            },
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            clearTrack(trackIndex: number) {
                // 什么都不做
                console.log(`[PIXI Mock] clearTrack(${trackIndex}) - noop`);
            },
        };
    };

    // 创建mock的spine对象
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const createMockSpine = (data?: any) => {
        const spine = {
            state: createMockSpineState(),
            x: 0,
            y: 0,
            scale: { x: 1, y: 1 },
            rotation: 0,
            visible: true,
            alpha: 1,
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            hackTextureBySlotName(slotName: string, texture: any) {
                // 什么都不做
                console.log(`[PIXI Mock] hackTextureBySlotName(${slotName}) - noop`);
            },
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            setSkin(skinName: string) {
                // 什么都不做
                console.log(`[PIXI Mock] setSkin(${skinName}) - noop`);
            },
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            setAttachment(slotName: string, attachmentName: string) {
                // 什么都不做
                console.log(`[PIXI Mock] setAttachment(${slotName}, ${attachmentName}) - noop`);
            },
            destroy() {
                // 什么都不做
                console.log(`[PIXI Mock] destroy() - noop`);
            },
            // 可能需要的其他属性
            interruptAlpha: 0,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            children: [] as any[],
        };

        // 添加可能需要的其他方法
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        (spine as any).update = (deltaTime?: number) => {
            // 什么都不做
        };

        return spine;
    };

    // 创建mock的Application对象
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const createMockApplication = (options?: any) => {
        const app = {
            stage: {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                addChild(child: any) {
                    // 什么都不做
                    console.log(`[PIXI Mock] stage.addChild() - noop`);
                },
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                removeChild(child: any) {
                    // 什么都不做
                    console.log(`[PIXI Mock] stage.removeChild() - noop`);
                },
                children: [] as any[],
            },
            view: options?.view || null,
            screen: {
                width: options?.width || 0,
                height: options?.height || 0,
            },
            renderer: {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                resize(width: number, height: number) {
                    // 什么都不做
                    console.log(`[PIXI Mock] renderer.resize(${width}, ${height}) - noop`);
                },
            },
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            resize(width: number, height: number) {
                // 什么都不做
                console.log(`[PIXI Mock] app.resize(${width}, ${height}) - noop`);
            },
            destroy(removeView?: boolean, stageOptions?: any) {
                // 什么都不做
                console.log(`[PIXI Mock] app.destroy(${removeView}) - noop`);
            },
        };

        return app;
    };

    // 创建mock的Assets对象
    const createMockAssets = () => {
        return {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            load(url: string | string[]): Promise<any> {
                console.log(`[PIXI Mock] Assets.load(${url}) - returning mock promise`);
                // 返回一个立即resolve的Promise，包含mock的spineData
                return Promise.resolve({
                    spineData: {
                        // mock的spine数据
                        skeleton: {
                            data: {
                                animations: [],
                                bones: [],
                                skins: [],
                            },
                        },
                    },
                });
            },
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            unload(url: string | string[]): Promise<any> {
                console.log(`[PIXI Mock] Assets.unload(${url}) - noop`);
                return Promise.resolve();
            },
        };
    };

    // 创建mock的PIXI对象
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const mockPIXI: any = {
        Application: createMockApplication,
        Assets: createMockAssets(),
        spine: {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            Spine: createMockSpine,
        },
        // 保留原有的其他属性（如果有的话）
    };

    // 如果window.PIXI已经存在，保留其非spine相关的属性
    if (window.PIXI && typeof window.PIXI === 'object') {
        Object.keys(window.PIXI).forEach(key => {
            if (key !== 'spine' && key !== 'Application' && key !== 'Assets') {
                mockPIXI[key] = (window.PIXI as any)[key];
            }
        });
    }

    return mockPIXI;
};

/**
 * 根据环境判断是否需要mock PIXI
 * 可以在这里添加环境判断逻辑
 */
export const shouldMockPIXI = () => {
    // 这里可以根据需要添加环境判断逻辑
    // 例如：开发环境、特定环境变量等
    // return process.env.NODE_ENV === 'development' || process.env.VUE_APP_MOCK_PIXI === 'true';
    
    // 暂时返回false，由调用方决定
    return false;
};

/**
 * 初始化PIXI Mock
 * 如果条件满足，会用mock版本替换window.PIXI
 */
export const initPIXIMock = (condition: boolean = false) => {
    if (condition && window.PIXI) {
        console.log('[PIXI Mock] 开始mock PIXI');
        const originalPIXI = window.PIXI;
        const mockPIXI = createMockPIXI();
        
        // 替换window.PIXI
        window.PIXI = mockPIXI;
        
        console.log('[PIXI Mock] PIXI已被mock，所有spine相关操作将不会实际执行');
        
        // 可以选择是否保留原始PIXI的引用
        (window as any).__ORIGINAL_PIXI__ = originalPIXI;
    }
};

